module.exports = __webpack_public_path__ + "img/deliveryContactManagers.cd96e44f.svg";